import React, { useRef } from 'react';
import { SiteNav, MinimalFooter, MobileAktionsleiste, useReveal, useTopProgress, useStartAnfrage } from './shared';
import Seo from './Seo';
import { MietpreisAnalyseTool } from './tools/MietpreisAnalysePage';
import {
  LandingHero,
  Stakes,
  TargetGroup,
  Methodology,
  Benefits,
  Platform,
  CaseStudies,
  Testimonials,
  Process,
  Expert,
  MidCTA,
  // Pakete,   // deaktiviert, siehe unten
  Location,
  FAQ,
  FinalCTA,
} from './sections';

/**
 * Erstanalyse landing page. Sections are imported from `./sections/` and can be
 * reused on other routes. Roman numerals on the section eyebrows are generated
 * automatically by CSS counters scoped to the `.numbered-sections` wrapper —
 * just reorder or omit sections and the numbering follows.
 */
export default function ErstanalysePage() {
  useReveal();
  useTopProgress();
  const formRef = useRef(null);

  // Note: ViewContent is no longer fired on page mount — it now fires when the
  // visitor plays the VSL (see LandingHero), so the event means "viewed our video".

  const startFunnel = useStartAnfrage();

  const navItems = [
    { label: 'Start', anchor: 'top' },
    { label: 'Methode', anchor: 'methode' },
    { label: 'Fallstudien', anchor: 'fallstudien' },
    { label: 'Über uns', anchor: 'ueber-uns' },
  ];

  return (
    <div className="page-enter numbered-sections" data-screen-label="02 Erstanalyse">
      <Seo
        path="/erstanalyse"
        title="Kostenlose Erstanalyse Ihrer Immobilien — hamba"
        description="Kostenlose Erstanalyse Ihres Portfolios: Mieten auf Marktniveau, Nebenkosten optimiert, Rückstände eingetrieben. Private Immobilienverwaltung im Rhein-Main-Gebiet."
      />
      <div id="homev2-progress" className="progress-bar" />
      <SiteNav />

      <div id="landing"><LandingHero onCTA={startFunnel} /></div>

      {/* Direkt unter dem Kurzformular des Aufmachers: Wer sich nicht gleich
          melden will, bekommt hier etwas, das sofort nuetzt — und hinterlaesst
          dabei dieselben Angaben. Dieselbe Komponente wie auf der Startseite
          und unter /kostenlose-mietpreis-analyse, keine Kopie. */}
      <div id="mietpreis"><MietpreisAnalyseTool eingebettet /></div>
      <div id="herausforderungen"><Stakes /></div>
      <div id="kunden"><TargetGroup /></div>
      <div id="methode"><Methodology /></div>
      <div id="vorteile"><Benefits /></div>
      <div id="system"><Platform /></div>
      <div id="fallstudien"><CaseStudies /></div>
      <div id="stimmen"><Testimonials /></div>
      <div id="prozess"><Process /></div>
      <div id="ueber-uns"><Expert /></div>
      {/* DEAKTIVIERT (Code bleibt) — Preissektion. Zum Einschalten diese
          Zeile und den Import oben wieder aktivieren. */}
      {/* <Pakete onCTA={startFunnel} /> */}
      <MidCTA onStartFunnel={startFunnel} />
      <div id="standort"><Location /></div>
      <div id="faq"><FAQ /></div>
      <div id="anfrage"><FinalCTA onStartFunnel={startFunnel} formRef={formRef} /></div>

      <MinimalFooter />

      {/* Nur auf schmalen Schirmen sichtbar; muss direktes Kind von
          .page-enter bleiben, sonst haelt das CSS unten keinen Platz frei. */}
      <MobileAktionsleiste />
    </div>
  );
}
